<template>
  <div>
    <dataVis></dataVis>
  </div>
</template>

<script>
import dataVis from '@/components/package/dataVisual.vue';
export default {
  components: {
    dataVis
  },
  name: 'allVis',
  data () {
    return {};
  },
  mounted () {},
  methods: {}
};

</script>
